import React, { FC } from 'react'
import { ModuleNames } from '../../../constants/componentNames.constants'

//* components
import ContentBlock from '../../global/contentBlock'
import ContentColumns from '../../global/contentColumns'
import ContentRows from '../../global/contentRows'
import Divider from '../../global/divider'
import FeaturedResource from '../../global/featuredResource'
import FlexibleHero from '../../global/flexibleHero'
import Grid from '../../global/grid'
import Hero from '../../global/hero'
import Icons from '../../global/icons'
import KeyStats from '../../global/keyStats'
import { LoadingContainer } from '../../global/loadingContainer'
import MainCTA from '../../global/mainCta'
import Marketo from '../../global/marketo'
import MarketoFormContainer from '../../global/marketo/style'
import MediaText from '../../global/mediaText'
import ResourceRow from '../../global/resourceRow'
import Slider from '../../global/slider'
import SpeakerText from '../../global/speakerText'
import Tiles from '../../global/tiles'
import { TopicItemLists } from '../../global/TopicItemLists'
import VideoSpotlight from '../../global/videoSpotlight'

type Props = {
  data: any
  locale: string
  location: any
}

export const Modules: FC<Props> = ({ data, locale, location }) => {
  let pageTitle: string = ''
  pageTitle = data?.pageName || data?.name

  return data.flexSection.map((module: any, i: number) => {
    switch (module.__typename) {
      case ModuleNames.DIVIDER:
        return <Divider data={module} key={`page-component--${i}`} />

      case ModuleNames.MEDIA_ASSET:
        return <MediaText data={module} key={`page-component--${i}`} pageType="events" />

      case ModuleNames.MEDIA_TEXT:
        return <MediaText data={module} key={`page-component--${i}`} pageType="events" />

      case ModuleNames.CONTENT_ROWS:
        return <ContentRows data={module} key={`page-component--${i}`} />

      case ModuleNames.GLOBAL_KEY_STATS:
        return <KeyStats data={module} key={`page-component--${i}`} />

      case ModuleNames.VIDEO_SPOTLIGHT:
        return <VideoSpotlight data={module} key={`page-component--${i}`} />

      case ModuleNames.GLOBAL_CONTENT_COLUMNS:
        return <ContentColumns data={module} pageType="events" key={`page-component--${i}`} />

      case ModuleNames.GLOBAL_CONTENT_BLOCK:
        return <ContentBlock data={module} key={`page-component--${i}`} />

      case ModuleNames.RESOURCE_ROW:
        return (
          <ResourceRow
            data={module}
            pageType="events"
            key={`page-component--${i}`}
            locale={locale}
          />
        )

      case ModuleNames.ICONS:
        return <Icons data={module} key={`page-component--${i}`} />

      case ModuleNames.FEATURED_RESOURCE:
        return (
          <FeaturedResource
            data={module}
            pageLocale={locale}
            pageType="events"
            key={`page-component--${i}`}
          />
        )

      case ModuleNames.SLIDER:
        return <Slider data={module} key={`page-component--${i}`} />

      case ModuleNames.HERO:
        return (
          <Hero
            data={module}
            location={location}
            pageTitle={pageTitle}
            pageType="events"
            showBreadcrumbs={true}
            key={`page-component--${i}`}
            metaInformation={data.metaInformation}
            pageUseCase="Events"
            breadcrumb={module?.breadcrumb || data?.breadcrumb}
            locale={locale}
          />
        )

      case ModuleNames.GLOBAL_MAIN_CTA:
        return <MainCTA data={module} locale={locale} key={`page-component--${i}`} />

      case ModuleNames.TILES:
        return <Tiles data={module} key={`page-component--${i}`} />

      case ModuleNames.MARKETO_FORM:
        return (
          <MarketoFormContainer key={`page-component--${i}`}>
            <div>
              {module.title && <p className="FormTitle">{module.title}</p>}
              {module.subtitle && <p className="FormSubtitle">{module.subtitle}</p>}

              <Marketo formData={module.marketoForm} />

              {module.marketoFinePrint && (
                <p className="FormFinePrint">{module.marketoFinePrint}</p>
              )}
            </div>
          </MarketoFormContainer>
        )

      case ModuleNames.SPEAKER_TEXT:
        return <SpeakerText data={module} key={`page-component--${i}`} />

      case ModuleNames.FLEXIBLE_HERO:
        return (
          <FlexibleHero
            data={module}
            location={location}
            pageTitle={pageTitle}
            pageType="events"
            showBreadcrumbs={!!data.breadcrumb}
            key={`page-component--${i}`}
            breadcrumb={data.breadcrumb}
            locale={locale}
          />
        )

      case ModuleNames.TOPIC_ITEM_LIST:
        return <TopicItemLists data={module} key={`page-component--${i}`} />

      case ModuleNames.ANCHOR_LINK:
        return <span key={`page-component--${i}`} id={module.identifier || ''}></span>

      case ModuleNames.LOADING_CONTAINER:
        return <LoadingContainer data={module} key={`page-component--${i}`} />

      case ModuleNames.GRID:
        return <Grid data={module} key={`page-component--${i}`} />
    }
  })
}
